import { useEffect, useRef } from 'react';

const layers = [
  'Tax residency',
  'Citizenship portfolio',
  'Banking and custody',
  'Asset domicile',
  'Operating company headquarters',
  'Personal mobility infrastructure',
  'Generational succession',
];

export default function SovereignStack() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="methodology"
      ref={sectionRef}
      data-testid="sovereign-stack-section"
      className="relative py-24 md:py-32 bg-[#efeee9]"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="text-center mb-14 reveal">
          <p
            className="text-sm uppercase tracking-[0.3em] text-[#1a7a7a] mb-4 font-medium"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Methodology
          </p>
          <h2
            className="text-4xl md:text-5xl font-semibold tracking-tight text-[#1a1a1a]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            The Strategic Discovery Session
          </h2>
        </div>

        <div className="max-w-3xl mx-auto reveal">
          <p
            className="text-gray-500 text-base leading-relaxed mb-10"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Most leaders have a cross-border setup that grew by accident. A country chosen for a school. A structure left over from an old deal. A residency picked up for a tax year that never closed. Global Citizen Consulting begins every engagement with The Strategic Discovery Session: a two to three hour working conversation across seven dimensions of your cross-border life. We listen for everything that informs the bespoke plan we then design for you.
          </p>

          <div className="rounded-2xl bg-white border border-gray-200 p-8 md:p-10">
            <ol className="space-y-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {layers.map((layer, i) => (
                <li
                  key={i}
                  data-testid={`sovereign-layer-${i}`}
                  className="flex items-baseline gap-4"
                >
                  <span className="text-[#1a7a7a] font-bold text-lg w-6 shrink-0 text-right">
                    {i + 1}
                  </span>
                  <span className="text-[#1a1a1a] text-base font-medium">
                    {layer}
                  </span>
                </li>
              ))}
            </ol>
          </div>

          <p
            className="text-[#1a1a1a] font-medium text-base mt-8 text-center"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            We are the first firm to look at all seven together.
          </p>
        </div>
      </div>
    </section>
  );
}
